import React from "react";
import outage_image from "../assets/outage.png"
import { Icon } from "pepsico-ds";

const Outage = ({ outageSystem}) => {
    return (
        <div 
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent:'center',
            textAlign: 'center',
            minHeight:'-webkit-fill-available'
          }}
        >
            <img src={outage_image} alt="system outage" className="mb-3" style={{width:'25%'}}/>
            <h4 className="mb-3" style={{display:'inline-flex',alignItems:'center',color: 'var(--Semantic-Neutrals-Orange-High, #D6AC16)',fontSize:'20px',gap:'4px'}}><Icon
                alt="alt value"
                className="$color-icon-default"
                icon="warning_amber"
                size="medium"
                style={{color:"#D6AC16"}}
                />Service Outage</h4>
            <p className="mb-0" style={{
                color: 'var(--Core-Gray-value-02, #818181)',
                fontSize: 'var(--Font-Size-H6, 14px)'
            }}>You may experience issues with {outageSystem} Portal.</p>
            
            <p
            className="mb-0"
            style={{
                color: 'var(--Core-Gray-value-02, #818181)',
                fontSize: 'var(--Font-Size-H6, 14px)',
            }}
            >
            Please check the{' '}
            <span
                onClick={() => window.location.reload()}
                style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                title="Click to refresh"
            >
                status
            </span>{' '}
            for real-time updates or contact Support for urgent help.
            </p>

        </div>
    );
};
export default Outage;